/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { GridComponentType } from "@nf/common";
import { useMemo } from "react";
import { isServerSideRender } from "@nf/helpers";

export const useGridPaddingCount = (gridScreen?: GridComponentType) => {
  const width = !isServerSideRender ? window.innerWidth : 0;
  const gridPadding = useMemo(() => {
    const isTabletSize = width <= 850 && width > 499;
    const isMobileSize = width <= 499;

    const defaultPadding = isTabletSize
      ? { col: 18, row: 12 }
      : isMobileSize
      ? { col: 10, row: 5 }
      : { col: 18, row: 10 };

    switch (gridScreen) {
      case GridComponentType.MovieDetails:
        return isTabletSize
          ? { col: 6, row: 14 }
          : isMobileSize
          ? { col: 6, row: 3 }
          : { col: 14, row: 28 };
      case GridComponentType.GenresScreen:
      case GridComponentType.PlaylistScreen:
      default:
        return defaultPadding;
    }
  }, [width]);

  return gridPadding;
};
